import { createSlice } from '@reduxjs/toolkit'

const initialMetaState = {
  resultCode: 0,
  processorID: '', // Not required for FE use
  clientSessionId: '',
  searchKey: '',
  searchId: '',
  requestId: '',
  hasExpressDeal: false,
  hasUpsellOptions: false,
  hasClosedUserGroupDeals: false,
  cheapestFlightNonStop: '',
  minimumRetailPrice: 0,
  minimumListingPrice: 0,
  nonStopPrice: 0,
  tripType: '',
  lowerBound: 0,
  upperBound: 30,
  totalItineraries: 0,
  totalFilteredItineraries: 0,
  defaultPackagePrice: null,
  selectedPackagePrice: null,
}

export const listingsMetaData = createSlice({
  name: 'listingsMetaData',
  initialState: initialMetaState,
  reducers: {
    setListingsMetaData: (state, action) => {
      // Set defaultPackagePrice from initial call and persist it for future requests if null
      // TODO remove this once USP sends default proposal in all responses, we don't have to save it anymore
      return {
        ...action.payload,
        defaultPackagePrice: state.defaultPackagePrice || action.payload.selectedPackagePrice,
      }
    },
  },
})

export const { setListingsMetaData } = listingsMetaData.actions
